import { contractDate } from '../utils/planningDates';
export const QUOTE_STATES = [
  "Créé",
  "Envoyé",
  "En négociation",
  "Signé",
  "Refusé",
  "Remplacé",
];
export function readQuoteWorkflow(scope) {
  try {
    const value = JSON.parse(localStorage.getItem(scope));
    return value && typeof value === "object" && !Array.isArray(value)
      ? value
      : {};
  } catch {
    return {};
  }
}
export function quoteTransition(
  current,
  { state, note, author, signer, signedAt, fileKey, revisionId },
  now = new Date(),
) {
  if (['Signé', 'Remplacé'].includes(current?.state)) throw new Error('Ce devis est finalisé. Son historique est conservé.');
  if (!QUOTE_STATES.includes(state)) throw new Error("État invalide");
  if (["Refusé", "En négociation"].includes(state) && !note?.trim())
    throw new Error("Précisez le motif ou les modifications demandées.");
  if (state === "Signé" && (!signer?.trim() || !contractDate(signedAt) || !fileKey))
    throw new Error("Indiquez le signataire, la date et le PDF signé.");
  if (state === "Remplacé" && !revisionId)
    throw new Error(
      "La nouvelle version doit être créée avant de remplacer le devis.",
    );
  const event = {
    state,
    note: note?.trim() || "",
    author,
    savedAt: now.toISOString(),
    signer,
    signedAt,
    fileKey,
    revisionId,
  };
  return {
    ...current,
    state,
    revisionId: revisionId || current?.revisionId,
    history: [event, ...(current?.history || [])],
  };
}
export function quotationEmail(quotation, client, recipient, note = "") {
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(recipient) || /[\r\n]/.test(recipient))
    throw new Error("Indiquez un email valide.");
  const subject = `J’M Intérim — Devis n° ${quotation.quotationNumber ?? "Provisoire"}`;
  const body = `Bonjour,\n\nVous trouverez en pièce jointe notre devis n° ${quotation.quotationNumber ?? "Provisoire"} pour ${client.companyName || "votre établissement"}.\n\n${note.trim() ? `${note.trim()}\n\n` : ""}Merci de nous retourner le devis signé ou de nous préciser les ajustements souhaités.\n\nCordialement,\nJ’M Intérim`;
  return `mailto:${encodeURIComponent(recipient)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
export async function quoteProof(action, id, file) {
  if (
    action === "put" &&
    (file?.type !== "application/pdf" || file.size > 10 * 1024 * 1024)
  )
    throw new Error("Choisissez un PDF de 10 Mo maximum.");
  const db = await new Promise((resolve, reject) => {
    const request = indexedDB.open("jm-quotation-proofs", 1);
    request.onupgradeneeded = () => request.result.createObjectStore("proofs");
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(
      "proofs",
      action === "get" ? "readonly" : "readwrite",
    );
    const store = transaction.objectStore("proofs");
    const request = action === "get" ? store.get(id) : store.put(file, id);
    transaction.oncomplete = () => {
      db.close();
      resolve(request.result);
    };
    transaction.onerror = () => {
      db.close();
      reject(transaction.error);
    };
    transaction.onabort = () => {
      db.close();
      reject(transaction.error);
    };
  });
}
